import { styled } from '@clickcease/cc-client-components-lib'

export const ReactivationPageStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const ReactivationPageTitle = styled('div', {
  fontWeight: '$b',
  fontSize: '$hxl',
  marginBottom: '$6',
})

export const ReactivationPageSubtitle = styled('div', {
  fontWeight: '$l',
  fontSize: '$lg',
  marginBottom: '$10',
  width: '390px',
  textAlign: 'center',
})

export const ReactivationEmail = styled('span', {
  color: '$primaryColor',
  textDecoration: 'underline',
  fontWeight: '$sb',
})
